module.exports = __webpack_public_path__ + "img/logininfor.182c8103.svg";